<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <filter v-if="isSuper == true">
        <li class="mt-0 nav-item">
          <h6 v-if="this.$store.state.isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">صفحات المرافق</h6>

          <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">GUESTBOOK</h6>
        </li>
        <li class="nav-item">
          <sidenav-item url="/dashboard" :class="getRoute() === 'dashboard' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'">
            <template v-slot:icon>
              <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </filter>
      <filter v-else>
        <li class="mt-0 nav-item">
          <h6 v-if="this.$store.state.isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">صفحات المرافق</h6>

          <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">GUESTBOOK</h6>
        </li>
        <li class="nav-item">
          <sidenav-item url="/dashboard" :class="getRoute() === 'dashboard' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'">
            <template v-slot:icon>
              <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item url="/watemplate" :class="getRoute() === 'watemplate' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'الجداول' : 'Message Template'">
            <template v-slot:icon>
              <i class="ni ni-chat-round text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item url="/guestcategory" :class="getRoute() === 'guestcategory' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Guest Category'">
            <template v-slot:icon>
              <i class="ni ni-ungroup text-success text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item url="/guests" :class="getRoute() === 'guests' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'الواقع الافتراضي' : 'Guests'">
            <template v-slot:icon>
              <i class="ni ni-tie-bow text-info text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item url="/tables" :class="getRoute() === 'virtual-reality' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'الواقع الافتراضي' : 'Guest Statistics'">
            <template v-slot:icon>
              <i class="ni ni-chart-bar-32 text-info text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="mt-3 nav-item">
          <h6 v-if="this.$store.state.isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">صفحات المرافق</h6>

          <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">WEB INVITATION</h6>
        </li>
        <li class="nav-item">
          <sidenav-item url="/settings" :class="getRoute() === 'settings' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'حساب تعريفي' : 'Settings / Customization'">
            <template v-slot:icon>
              <i class="ni ni-send text-success text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item url="/comments" :class="getRoute() === 'comments' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'تسجيل الدخول' : 'Comments Approval'">
            <template v-slot:icon>
              <i class="ni ni-chat-round text-danger text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </filter>
      <li class="mt-3 nav-item">
        <h6 v-if="this.$store.state.isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">صفحات المرافق</h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">MANAGEMENT TOOLS</h6>
      </li>
      <li v-if="isSuper" class="nav-item">
        <sidenav-item url="/account" :class="getRoute() === 'account' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'حساب تعريفي' : 'Account Management'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="!isSuper" class="nav-item">
        <sidenav-item url="/account-reception" :class="getRoute() === 'account-reception' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'حساب تعريفي' : 'Account Management'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      

      <li v-if="isSuper == true" class="nav-item">
        <sidenav-item url="/signin" :class="getRoute() === 'signin' ? 'active' : ''" :navText="this.$store.state.isRTL ? 'تسجيل الدخول' : 'Events Management'">
          <template v-slot:icon>
            <i class="ni ni-shop text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer"></div>
</template>
<script>
  import SidenavItem from "./SidenavItem.vue";
  import sha256 from "crypto-js/sha256";

  export default {
    name: "SidenavList",
    props: {
      cardBg: String,
    },
    data() {
      return {
        title: "Argon Dashboard 2",
        controls: "dashboardsExamples",
        isActive: "active",
      };
    },
    computed: {
      isSuper() {
        return this.$store.state.user.is_super_admin;
      },
    },
    components: {
      SidenavItem,
    },
    methods: {
      getRoute() {
        const routeArr = this.$route.path.split("/");
        return routeArr[1];
      },
      encrypt(ele) {
        return sha256(ele);
      },
    },
  };
</script>